import { Component, ViewChild, Renderer } from '@angular/core';
import { ViewController, ItemSliding, Item, AlertController, Searchbar,} from 'ionic-angular';

import { UserMyRadiant as User, NotificationProvider } from '../../../providers';
import { Nav,Events} from 'ionic-angular';

import { RepositoryMyRadiant, HelperMyRadiant, ApiMyRadiant} from '../../../providers';
import { Utility } from '../../../providers/resources/utility';
import { AprovalDetail } from './aproval_detail/page';

@Component({
  selector: 'aproval-page',
  templateUrl: 'page.html'
})
export class Aproval {

  @ViewChild('cardContent') cardContent;

  berita:any = '';
  loading : any;
  isLogin : any = 0;
  enableRefresh = false;
  data = {
    activity:[],
    jmlNotifikasi : 0,
  };
  state = {
    searching : true,
  };
  startDate:any = new Date;
  valDateJarak:any;
  today = this.helper.getToday();
  parameter : any = {
    id  : this.userApi.data.Employee_ID,
    nik : this.userApi.data.NIK,
  }
  constructor(
    private api               : ApiMyRadiant,
    public userApi            : User,
    public alertCtrl          : AlertController,
    public nav                : Nav,
    public utility            : Utility,
    public repositoryProvider : RepositoryMyRadiant,
    public helper             : HelperMyRadiant,
    public viewCtrl           : ViewController,
    public events             : Events,
    public notifProvider      : NotificationProvider,
    public renderer           : Renderer,
  ) {
    
    this.getRequest();
    events.subscribe('aproval:reload',() => {
      this.getRequest();
    });
    this.notifProvider.refreshNotification();

    events.subscribe('notification:update',(notifikasi) => {
      this.data.jmlNotifikasi = notifikasi.jml_notifikasi;
    });
  }

  ngAfterViewInit() {
    this.renderer.listen(this.cardContent.nativeElement, 'scroll', (event) => {
      let scrollTop = event.target.scrollTop;
    
      if (scrollTop > 0) {
        this.enableRefresh = false;
      } else {
        this.enableRefresh = true;
      }
    
      });
    }

  detailAproval(id,employee_id,state){
    if (state=='request') {
      this.nav.push(AprovalDetail,{request_id:id,employee_id:employee_id});
    }
  }

  refresh(refresher){
    this.getRequest();
    setTimeout(() => {
      console.log('Async operation has ended');
      refresher.complete();
    }, 1000);
  }

  getRequest(){
    this.loading = this.helper.showLoading('Loading Data..');
    let me = this;
    this.repositoryProvider.getRequestAproval(this.parameter).subscribe((resp:any) => {
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
      if(resp.success){
        me.data.activity = resp.data;
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/aproval/page.ts